import React from 'react';
import {
  FormControl,
  InputLabel,
  Select as MuiSelect,
  FormHelperText,
} from '@mui/material';

function Select(props) {
  const {
    // eslint-disable-next-line react/prop-types
    name, sx, label, children, value, error, onChange, input, renderValue, ...others
  } = props;

  return (
    <FormControl sx={sx} error={!!error}>
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        input={input}
        renderValue={renderValue}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...others}
      >
        {children}
      </MuiSelect>
      {
        error && <FormHelperText>{error}</FormHelperText>
      }
    </FormControl>
  );
}

export default Select;
